import { useContext } from "react"
import { BurgerMenu, Dot, UserMenu } from "@components"
import { SidebarContext, UserContext } from "@context"
import { decodeToken, getInitials, getSbUrl, hasRight } from "@helpers"
import { XMarkIcon } from "@heroicons/react/24/outline"
import { useImpersonateUser } from "@hooks"

const NavbarButton = ({ active, caption, link }) => {
  if (active) return <a href={link} className="px-3 py-2 text-sm font-medium text-white rounded-md bg-navbar-active">{caption}</a>

  return <a href={link} className="px-3 py-2 text-sm font-medium text-gray-300 rounded-md hover:bg-navbar-hover hover:text-white" aria-current="page">{caption}</a>
}

const TopNavbar = () => {
  const { user } = useContext(UserContext)
  const { showSidebar } = useContext(SidebarContext)
  const clientName = user.me.client.menu_display_name || user.me.client.name
  const initials = getInitials(user?.me?.name || "")
  const jwtUser = decodeToken(localStorage?.adminToken || null)
  const isImpersonating = jwtUser?.impersonating || false
  const { logoutStaff } = useImpersonateUser()

  return (
    <nav className="fixed w-full z-[60] bg-sb-blue">      
      <div className="px-2 mx-auto sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-between h-16">
          <div className="flex items-center justify-between flex-1 sm:items-stretch">
            <div className="flex items-center flex-shrink-0 font-semibold text-white">
              <BurgerMenu className="mr-2 xl:hidden" handleClick={() => showSidebar(true)} /><span className="lg:max-w-[320px] xl:max-w-none whitespace-nowrap overflow-hidden">{clientName}</span>
            </div>

            {!isImpersonating && (
              <div className="hidden lg:ml-6 lg:block">
                <div className="flex space-x-4">
                  {hasRight("bookings") && <NavbarButton link={getSbUrl("/apps/bookings")} caption="Bookings" />}
                  {hasRight("lettings") && <NavbarButton link={getSbUrl("/apps/let")} caption="Lettings" />}
                  <NavbarButton link="#" active caption="Parents" />
                  {hasRight("reports") && <NavbarButton link={getSbUrl("/apps/reports")} caption="Reports" />}
                  {hasRight("admin") && <NavbarButton link={getSbUrl("/apps/administration")} caption="Administration" />}
                </div>
              </div>
            )}
          </div>
  
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
            <div className="relative ml-3">
              {!isImpersonating && (
                <UserMenu initials={initials} />
              )}

              {isImpersonating && (
                <div className="flex items-center py-1 text-white bg-indigo-600 rounded-full">
                  <div className="flex items-center mx-4 space-x-2">
                    <Dot color="live" pulse={true} />
                    Impersonating <span className="ml-2 font-bold">{jwtUser?.impersonated_user}</span>
                  </div>

                  <XMarkIcon className="w-4 h-4 mr-4 cursor-pointer" onClick={() => logoutStaff()}/>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default TopNavbar
